export const CONTENT_ITEMS = {
    LOGIN_FORM: 'BAD413DA-EF54-411A-8EA2-48B4DF76D479',
    MY_PROFILE: '21C354B5-ED72-4F8D-A58A-87EF354A149A',
    EDIT_FORM: '64C4C04D-45F9-425E-94BC-2E6D38FFC01C',
    AGENT_FORM: '81310BBF-9037-4E77-A646-0C86C4198A1E',
    AGENTS_LIST: '0DC9E933-A3FA-41D3-A94A-5F412AAD8635',
    AGENTS_FILTERS: 'AB3AC8B3-62F3-45D2-AA0D-01EEC55B3E53',
    REMOVE_PROFILE_MODAL: 'ABDC8B98-DE14-4CF2-9969-E7F2D6EDD5E2',
    RESET_PASSWORD_MODAL: '64F85CD2-86E3-4E77-841A-97D701422234',
    PENDING_REQUESTS_LIST: 'BB13BF10-C01B-4DEA-914E-9AE3C26FFC88',
    PENDING_REQUESTS_SELECTION: '3B056434-9BB8-42F1-A295-AC850103F231',
    UPDATE_PENDING_REQUESTS_MODAL: '4498CC78-7374-4972-8193-AF9E6A96E7D4'
};

export const PAGES_CONTENT_ITEMS = {
    LOGIN: '2F8C3ADD-1A56-48E8-9CDF-E5AAF599918C',
    FORGOT_PASSWORD: '89FD7FCC-873D-4067-8908-1E4FBBA1B3A2',
    FORGOT_USERNAME: '96E39200-CB79-4147-B73E-2CBBB26C2350',

    EDIT_PROFILE: 'B1AC7B54-5787-4355-B89E-CA7BFFBBFF1C',
    MANAGE_AGENTS: 'E48FA1E4-336B-458B-9B5D-2EBDD58CBA6D',
    EDIT_AGENT: 'C240E1FF-45B6-4661-9768-1B99F7783DB9',
    ADD_AGENT: '33D579B5-2128-4028-A7CC-D06C75F9F817',

    PENDING_REQUESTS: '2174EF84-6312-44FA-A9E2-93E024054276',
}